<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { fade } from 'svelte/transition';
    import ImageViewer from 'iv-viewer';
    import { shareAlt } from 'ionicons/icons/index.mjs';
    export let media;
    let loading = true;
    let error = "";
    let renderer = null;

    let image = "";
    let crop = { x: 0, y: 0 };
    let zoom = 1;
    let viewer = null;

	const dispatch = createEventDispatcher();
    onMount(async () => {
        image = media.uri;
        if (media.type == "360") {
            load360();
        }
        else if (media.type == "image") {
            loadImage();
        }
    });

    function loadImage() {
        const container = document.querySelector('#mb-preview');
        viewer = new ImageViewer(container, {});

        viewer.load(image);
    }

    function load360() {
        pannellum.viewer('panorama', {
            panorama: image,
            autoLoad: true
        });
    }
</script>

<div id="stage" in:fade>
    {#if media.type == "image"}
        <div id="mb-preview" class="preview"></div>
    {:else if media.type == "360"}
        <div id="panorama" class="threejs"></div>
    {:else if media.type == "pdf"}
        <div id="mb-preview" class="preview">
            <iframe class="iframe" title="media" frameBorder="0" src={media.uri} />
        </div>
    {:else if media.type == "document"}
        <div id="mb-preview" class="preview">
            <iframe class="iframe" title="media" frameBorder="0" src={"https://docs.google.com/viewer?url=" + encodeURIComponent(media.uri) + "&embedded=true"} />
        </div>
    {:else if media.type == "audio" || media.type == "video"}
        <div id="mb-preview" class="preview">
            <iframe class="iframe" title="media" frameBorder="0" src={media.uri} />
        </div>
    {:else}
        <div id="mb-preview" class="preview text-center" style="padding-top:100px;">
            <p class="empty-title h5">Preview not supported.</p>
        </div>
    {/if}
</div>

<style>
    #stage {
        overflow: hidden;
        width: 100%;
        height: 100vh;
    }
    .preview {
        width: 100%;
        height: 100%;
    }
    .threejs {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .iframe {
        width: 100%;
        height: 100%;
    }
</style>